import { assesmentDetailsEndPoints } from "./endPoints";
import { IaApiClient } from "src/network/iaApiClient";
import toastManager from "src/helpers/toastManager";

class AssesmentRepository {
    createAssessment = async (body) => {
        let data = await IaApiClient.post(assesmentDetailsEndPoints.createAssessment(), body).catch((err) => {
            console.log("Error", err);
            toastManager.error("Failed to create assessment");
        });
        return data;
    }

    getAssessmentDetails = async (owner) => {
        let data = await IaApiClient.get(assesmentDetailsEndPoints.getAssessmentDetails(owner)).catch((err) => {
            console.log("Error", err);
        });
        return data;
    }

    getAssessmentDetailsByOrgId = async (orgId) => {
        let data = await IaApiClient.get(assesmentDetailsEndPoints.getAssessmentDetailsByOrgId(orgId)).catch((err) => {
            console.log("Error", err);
        });
        return data;
    }

    getAssessmentDetailsById = async (assessmentId) => {
        let data = await IaApiClient.get(assesmentDetailsEndPoints.getAssessmentDetailsById(assessmentId)).catch((err) => {
            console.log("Error", err);
        });
        return data;
    }

    getUserResponsesById = async (projectId) => {
        let data = await IaApiClient.get(assesmentDetailsEndPoints.getUserResponsesById(projectId)).catch((err) => {
            console.log("Error", err);
        });
        return data;
    }

    createCurateResponse = async (projectId, body) => {
        let data = await IaApiClient.post(assesmentDetailsEndPoints.createCurateResponse(projectId), body).catch((err) => {
            console.log("Error", err);
        });
        return data;
    }

    getCuratedResponses = async (projectId) => {
        let data = await IaApiClient.get(assesmentDetailsEndPoints.getCuratedResponses(projectId)).catch((err) => {
            console.log("Error", err);

        });
        return data;
    }

    createDiscardedResponse = async (projectId, body) => {
        let data = await IaApiClient.post(assesmentDetailsEndPoints.createDiscardedResponse(projectId), body).catch((err) => {
            console.log("Error", err);
        });
        return data;
    }

    getDiscardedResponses = async (projectId) => {
        let data = await IaApiClient.get(assesmentDetailsEndPoints.getDiscardedResponses(projectId)).catch((err) => {
            console.log("Error", err);

        });
        return data;
    }

    updateAssessmentDetails = async (asssessmentId, body) => {
        let data = await IaApiClient.post(assesmentDetailsEndPoints.updateAssessmentDetails(asssessmentId), body).catch((err) => {
            console.log("Error", err);
        });
        return data;
    }

    uploadFiles = async (formData) => {
        let data = await IaApiClient.upload(assesmentDetailsEndPoints.uploadFiles(formData)).catch((err) => {
            console.log("Error", err);
            toastManager.error("Failed to upload files");
        });
        return data;
    }

    deleteFiles = async (keys) => {
        let data = await IaApiClient.post(assesmentDetailsEndPoints.deleteFiles(),{keys}).catch((err) => {
            console.log("Error", err);
            toastManager.error("Failed to delete files");
        });
        return data;
    }

    getAssessmentDetailsOfAllOrgs = async (orgArray) => {
        let data = await IaApiClient.post(assesmentDetailsEndPoints.getAssessmentDetailsOfAllOrgs(), orgArray).catch((err) => {
            console.log("Error", err);

        });
        return data;
    }
    
    setAssessmentStatusToCurated = async (assessmentId) => {
        let data = await IaApiClient.post(assesmentDetailsEndPoints.setAssessmentStatusToCurated(assessmentId)).catch((err) => {
            console.log("Error", err);
        });
        return data;
    }

    prepareDataForReportGeneration = async (assessmentId) => {
        let data = await IaApiClient.post(assesmentDetailsEndPoints.prepareDataForReportGeneration(assessmentId)).catch((err) => {
            console.log("Error", err);
        });
        return data;
    }

    getDataPreperationStatus = async (assessmentId) => {
        let data = await IaApiClient.get(assesmentDetailsEndPoints.getDataPreperationStatus(assessmentId)).catch((err) => {
            console.log("Error", err);
        });
        return data;
    }
    
    createReport = async (assessmentId) => {
        let data = await IaApiClient.post(assesmentDetailsEndPoints.createReportGenerationRequest(assessmentId)).catch((err) => {
            console.log("Error", err);
        });
        return data;
    }

    getReportStatus = async (assessmentId) => {
        let data = await IaApiClient.get(assesmentDetailsEndPoints.getReportGenerationStatus(assessmentId)).catch((err) => {
            console.log("Error", err);
        });
        return data;
    }


}

const assesmentRepository = new AssesmentRepository();
export { assesmentRepository as AssesmentRepository };
